module.exports = __webpack_public_path__ + "img/icn-sportsbook-check.7611b3a1.png";